import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function PourquoiCritique() {
  const { t } = useTranslation('blogchoisir');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section ref={ref} id="critique" className="scroll-mt-28">
      <div className={`bg-slate-primary rounded-xl p-6 md:p-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        <h2 className="font-manrope font-bold text-white text-xl md:text-2xl lg:text-3xl mb-5">
          {t('critique_h2')}
        </h2>
        <div className="space-y-4">
          <p className="text-white/70 text-sm md:text-base leading-relaxed">{t('critique_p1')}</p>
          <p className="text-white/70 text-sm md:text-base leading-relaxed">{t('critique_p2')}</p>
          <p className="text-white/70 text-sm md:text-base leading-relaxed">{t('critique_p3')}</p>
        </div>
      </div>
    </section>
  );
}